export const environment = {
  api_endpoints: {
    budgets: '/budgets',
    clockEmployee: '/v1/timesheet/admin',
    clockIn: '/v1/timesheet/in',
    clockOut: '/v1/timesheet/out',
    festivities: '/festivities/:year',
    holidays: '/holidays',
    holidaysAcceptPendingPast: '/holidays/admin/acceptPendingPast',
    holidaysByPeriod: '/holidays/:period',
    holidaysEmployee: '/holidays/admin/:employee',
    login: '/v1/auth',
    passwordChange: '/v1/auth/pass',
    timesheet: '/v1/timesheet',
    timesheetByPeriod: '/v1/timesheet/:period',
    timesheetByPeriodEmployee: '/v1/timesheet/admin/:employee/:period',
    users: '/v1/auths',
    vehicles: '/vehicles',
    works: '/works'
  },
  api_server: 'https://registrohorarioapi.talentosoftware.com',
  company: 'ts',
  dateFormat: {
    complete: 'DDMMYYYYHHmm',
    day: 'DDMMYYYY',
    month: 'MMYYYY',
    year: 'YYYY'
  },
  logLevel: 1,
  menu: ['timesheet'],
  production: false,
  resources: {
    mocks: {
      holidays: '/assets/resources/mocks/holidays.json',
      vehicleSectionsByType: '/assets/resources/mocks/vehicleSectionsByType.json',
      vehicleTypes: '/assets/resources/mocks/vehicleTypes.json',
      workers: '/assets/resources/mocks/workers.json',
      works: 'assets/resources/mocks/works.json',
    }
  },
  routePath: 'ts',
};
